var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!this.authorized)?_c('div',[_c('BaseNotAuthorized')],1):_vm._e(),(this.authorized)?_c('div',_vm._l((_vm.users),function(user){return _c('UserList',{key:user.uid,attrs:{"user":user}})}),1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }